export const baseFilterFieldModel = (fieldType, valuesToSet = {}) => ({
  values: valuesToSet.values || [], // For string/date with =, !=
  startDate: valuesToSet.startDate || null, //date with range
  endDate: valuesToSet.endDate || null, //date with range
  minValue: typeof valuesToSet.minValue === 'number' ? valuesToSet.minValue : null, // numeric
  maxValue: typeof valuesToSet.maxValue === 'number' ? valuesToSet.maxValue : null, // numeric
  operator:
    valuesToSet.operator || (!['datetime', 'datetime2'].includes(fieldType) && fieldType !== 'int' ? 'in' : 'null'),
  refreshKey: Math.floor(Math.random() * 111110),
  includeNulls: valuesToSet.includeNulls || null // for numeric
});

export const generateFilterObject = (name, selectionObject, distinctFields = []) => {
  const field = distinctFields.find((item) => item.Field === name);
  return {
    name,
    values: selectionObject.values || [],
    minValue: selectionObject.minValue,
    maxValue: selectionObject.maxValue,
    // When date field has in / not in operator then no need to pase range
    // In that case the value will be there in the values
    range:
      selectionObject.type === 'date' && (selectionObject.operator === 'null' || selectionObject.operator === 'range')
        ? {
            startDate: selectionObject.startDate,
            finishedDate: selectionObject.endDate
          }
        : undefined,
    operator: selectionObject.operator,
    isNumericType: selectionObject.isNumeric,
    type: field && field.Type ? field.Type : selectionObject.type,
    seperator: selectionObject.seperator,
    includeNulls: selectionObject.includeNulls,
    isLatLonFilter: selectionObject.isLatLonFilter
  };
};

export const filterQuery = (quicklink) => {
  const urlSearchParams = new URLSearchParams(quicklink.navigateTo.substring(quicklink.navigateTo.indexOf('?') + 1));
  return Object.fromEntries(urlSearchParams.entries());
};
